import { render, staticRenderFns } from "./ToShipped.vue?vue&type=template&id=f72010da"
import script from "./ToShipped.vue?vue&type=script&lang=js"
export * from "./ToShipped.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports